import React from 'react';
import { observer } from 'mobx-react';
import ReactHookSelect from 'react-hook-select';
import NumberFormat from 'react-number-format';
import { ReactComponent as LeftArrow } from 'Assets/svg/left-arrow.svg';
import userDetail from 'Stores/userDetail';
import Utils from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import { commonUpgradePopupState } from 'Components/common/commonUpgradePopup';
import { trialUserPaginationPopupState } from './trialUserPaginationPopup';

const { MX_AS_EVENTS, UPGRADE_TRIGGERS } = CONSTANTS;
const { LB_AS_PAGINATION_CLICK, AS_PAYWALL_PRICING_POPUP } = MX_AS_EVENTS;

const itemPerPageValues = [
  { label: '15', value: 15 },
  { label: '25', value: 25 },
  { label: '50', value: 50 },
  { label: '75', value: 75 },
  { label: '100', value: 100 },
];

const Pagination = observer(props => {
  const {
    currentPage = 1,
    totalCount = 0,
    rowsPerPage = 50,
    onRowsPerPageUpdate,
    updateCurrentPage,
    pageName = '',
    rowsPerPageValues = itemPerPageValues,
    showRowsPerPage = true,
    showTotalLogs = true,
    totalText = 'Total Records',
  } = props;

  const totalPage =
    totalCount % rowsPerPage === 0
      ? Math.floor(totalCount / rowsPerPage)
      : Math.floor(totalCount / rowsPerPage) + 1;

  const handleNext = () => {
    if (pageName === 'advSearchContact' || pageName === 'advSearchCompany') {
      Utils.mixpanelTrack(LB_AS_PAGINATION_CLICK, {
        pageName,
      });

      if (Utils.checkIsEmailVerified(true))
        if (userDetail.isFreeTrial) {
          trialUserPaginationPopupState.setShowPaginationTrialUserPopup(true);
        } else if (!Utils.checkIsPaginationEnabled() && pageName !== '') {
          Utils.mixpanelTrack(AS_PAYWALL_PRICING_POPUP, {
            btnSource: 'Pagination',
          });
          commonUpgradePopupState.setShowUpgradePopup(
            UPGRADE_TRIGGERS.PAGINATION,
          );
        } else {
          updateCurrentPage(currentPage, '+');
        }
    } else {
      updateCurrentPage(currentPage, '+');
    }
  };

  return (
    <div className={`pagination-wrapper${showTotalLogs ? '' : ' no-logs'}`}>
      {showTotalLogs && totalCount > 0 && (
        <div className="total-count">
          <span>{`${totalText}:`}</span>{' '}
          <NumberFormat
            thousandSeparator
            displayType="text"
            value={totalCount}
          />
        </div>
      )}
      {(totalPage > 1 || totalCount > rowsPerPageValues[0].value) && (
        <div className="pagination-controls">
          {showRowsPerPage && (
            <div className="page-count-wrap">
              <div className="text">Rows per page</div>
              <ReactHookSelect
                selectWrapperProps={{ className: 'pagination-dropdown' }}
                options={
                  Utils.getUserType() === 'PAID'
                    ? rowsPerPageValues
                    : rowsPerPageValues.filter(page => page.value <= 50)
                }
                defaultValue={[rowsPerPage]}
                getValue={value => {
                  onRowsPerPageUpdate(value[0]);
                }}
              />
            </div>
          )}
          <span className="divider" />
          <div className="pagination">
            <div className="text">
              Pages{' '}
              <NumberFormat
                thousandSeparator
                displayType="text"
                value={currentPage}
              />{' '}
              of{' '}
              <NumberFormat
                thousandSeparator
                displayType="text"
                value={totalPage}
              />
            </div>
            <span
              className={`previous-page${currentPage === 1 ? ' disable' : ''}`}
              onClick={() => {
                if (currentPage !== 1) updateCurrentPage(currentPage - 2, '-');
              }}
            >
              <LeftArrow />
            </span>
            <span
              className={`next-page${
                currentPage === totalPage ? ' disable' : ''
              }`}
              onClick={() => {
                if (currentPage !== totalPage) handleNext();
              }}
            >
              <LeftArrow />
            </span>
          </div>
        </div>
      )}
    </div>
  );
});

export default Pagination;
